let lastUpdate = null;
let diff = null; // in ms

export function syncTime() {
    return fetch('/time')
        .then(res => res.json())
        .then(json => {
            const serverTime = new Date(json.now);
            const now = new Date();
            diff = serverTime - now;
            lastUpdate = now;

            console.log('sync time: diff=' + diff + '; lastUpdate=' + lastUpdate)
        });
}

export function getTime() {
    const now = new Date();
    now.setTime(now.getTime() + diff ?? 0);
    return now;
}
